import {Button, Grid, IconButton} from "@mui/material";
import InstallmentsRadioGroup from "./InstallmentsRadioGroup";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DeleteIcon from "@mui/icons-material/Delete";
import React from "react";


export default function InstallmentsSwitchForm({
                                                   parcelList,
                                                   parcelaPaga, setParcelaPaga,
                                                   parcelaAberta, setParcelaAberta,
                                                   files, setFiles
                                               }) {

    const parcelasPagas =
        (parcelList?.filter(item => item.status === 'PAGA'))
    const parcelasAbertas =
        (parcelList?.filter(item => item.status === "CRIADA" || item.status === 'VENCIDA'))


    const handleAddFiles = (event) => {
        const selectedFiles = Array.from(event.target.files);
        setFiles([...files, ...selectedFiles]);
    };

    const handleRemoveFile = (index) => {
        setFiles(files.filter((_, i) => i !== index));
    };

    return <>
        <Grid container spacing={2}>
            <InstallmentsRadioGroup
                installments={parcelasPagas}
                tittle='Parcelas Pagas'
                selectedInstallment={parcelaPaga}
                setInstallment={setParcelaPaga}
            />

            <InstallmentsRadioGroup
                installments={parcelasAbertas}
                tittle='Parcelas Em Aberto'
                selectedInstallment={parcelaAberta}
                setInstallment={setParcelaAberta}
            />
        </Grid>


        <div className={'text-center mt-4'}>
            <input
                accept="image/*,application/pdf"
                style={{display: 'none'}}
                id="contained-button-file"
                multiple
                type="file"
                onChange={handleAddFiles}
            />
            <label htmlFor="contained-button-file">
                <Button variant="contained" color="primary" component="span" style={{marginRight: '10px'}}>
                    <UploadFileIcon/>&nbsp;&nbsp;Adicionar Evidências
                </Button>
            </label>

            <ul style={{listStyle: 'none'}}>
                {files.map((file, index) => (
                    <li key={index}>
                        {file.name}
                        <IconButton onClick={() => handleRemoveFile(index)} aria-label="remove file">
                            <DeleteIcon/>
                        </IconButton>
                    </li>
                ))}
            </ul>
        </div>
    </>
}